<ng-template let-t transloco>
    <div class="flex flex-col flex-auto md:w-220 md:min-w-220 min-h-120 max-h-90vh -m-6">

        <!-- Header -->
        <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
            <div class="text-lg font-medium invisible md:visible">{{trackIndex + 1 + "."}}
                {{trackForm.get('title').value}} {{trackForm.get('version').value ? '(' + trackForm.get('version').value
                + ')' : ''}}</div>

            <div class="flex space-x-4 items-center justify-center">
                <button (click)="fillFormData()" [color]="'accent'" class="px-6" mat-flat-button
                    matTooltip="{{t('track-form-auto-fill-description')}}" type="button">
                    {{t('track-form-auto-fill')}}
                </button>
                <button (click)="matDialogRef.close()" [tabIndex]="-1" mat-icon-button>
                    <mat-icon [svgIcon]="'heroicons_outline:x-mark'" class="text-current"></mat-icon>
                </button>
            </div>

        </div>

        <form (ngSubmit)="onSubmit()" [formGroup]="trackForm"
            class="grid grid-cols-1 items-start w-full p-6 sm:p-8 space-y-6 pb-2 overflow-auto" id="track-form">

            <div class="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0">
                <!-- Title -->
                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full md:w-2/3">
                    <mat-label>Title</mat-label>
                    <input [formControlName]="'title'" autocomplete="off" matInput required>
                </mat-form-field>

                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full md:w-1/3">
                    <mat-label>Version</mat-label>
                    <input [formControlName]="'version'" matInput name="track-version">
                </mat-form-field>
            </div>

            <div class="flex flex-col w-full space-y-6 md:space-y-0">
                <div class="w-full mb-2 flex flex-col md:flex-row align-middle justify-between">
                    <label class="flex items-center font-semibold">Participants</label>
                    <button class="h-8 min-h-8 max-h-8" (click)="addParticipant(undefined, $event)" [tabIndex]="-1"
                        color="primary" mat-flat-button type="button">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'" class="text-current icon-size-5"></mat-icon>
                    </button>
                </div>
                <ng-container formArrayName="participants"
                    *ngFor="let participant of trackForm.get('participants')['controls']; let i = index;">
                    <div class="w-full grid grid-cols-12 space-x-2" [formGroupName]="i">
                        <mat-form-field class="col-span-3">
                            <mat-select formControlName="role" required>
                                <ng-container *ngFor="let role of participantRoles">
                                    <mat-option [value]="role">{{role}}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-span-8">
                            <input formControlName="participant" placeholder="Participant Name"
                                (focusout)="onArtistBlur($event, i)" (keydown)="participantInputKeyDown($event)"
                                (focus)="onParticipantFocus(i)" [matAutocomplete]="artistAutoComplete" matInput
                                required>
                            <mat-autocomplete #artistAutoComplete="matAutocomplete"
                                (optionSelected)="onParticipantAutocomplete($event, i)"
                                [displayWith]="getArtistName.bind(this)">
                                <mat-option *ngFor="let artist of filteredArtists | slice : 0 : 10" [value]="artist" (pointerdown)="autocompleteMouseDown($event)">
                                    {{artist.title}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <button class="h-8 min-h-8 max-h-8 mt-2" (click)="deleteParticipant(i)" [tabIndex]="-1"
                            color="accent" mat-flat-button type="button">
                            <mat-icon [svgIcon]="'heroicons_outline:trash'" class="text-current icon-size-5">
                            </mat-icon>
                        </button>
                    </div>
                </ng-container>
                <mat-error *ngIf="trackForm.get('participants').errors?.share">The total revenue share of all
                    participants cannot exceed 100%.</mat-error>
                <mat-error *ngIf="trackForm.get('participants').errors?.primaryArtist">The release needs at least
                    one Main Artist.</mat-error>
            </div>

            <div class="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0">
                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full md:w-1/2">
                    <mat-label>Genre</mat-label>
                    <mat-select [formControlName]="'primaryGenre'" [compareWith]="compareByUuid">
                        <ng-container *ngFor="let genre of genres">
                            <mat-option [value]="genre">
                                {{genre.title}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full md:w-1/2">
                    <mat-label>Subgenre</mat-label>
                    <mat-select [formControlName]="'subGenre'" [compareWith]="compareByUuid">
                        <mat-option [value]="null"></mat-option>
                        <ng-container *ngFor="let genre of genres">
                            <mat-option [value]="genre">
                                {{genre.title}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0">
                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full md:w-1/2">
                    <mat-label>Audio Language</mat-label>
                    <mat-select [formControlName]="'language'" [compareWith]="compareByUuid" required>
                        <mat-option [value]="'0'">No Linguistic Content</mat-option>
                        <ng-container *ngFor="let language of languages">
                            <mat-option [value]="language">
                                {{t("lang." + language.alpha3)}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full md:w-1/2">
                    <mat-label>Parental Advisory</mat-label>
                    <mat-select [formControlName]="'explicit'">
                        <mat-option [value]="false">None</mat-option>
                        <mat-option [value]="true">Explicit Language</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <mat-form-field *ngIf="trackForm.get('language').value !== '0'"
                class="fuse-mat-textarea fuse-mat-no-subscript w-full">
                <mat-label>Lyrics</mat-label>
                <textarea [formControlName]="'lyrics'" [rows]="2" autocomplete="off" matInput matTextareaAutosize>
            </textarea>
            </mat-form-field>

            <div class="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0">
                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full">
                    <mat-label>{{"isrc" | transloco}} <form-field-tooltip tooltipTitleKey="isrc"
                        tooltipKey="track-isrc-tooltip">
                    </form-field-tooltip></mat-label>
                    <input [formControlName]="'isrc'" autocomplete="off" matInput>
                </mat-form-field>

                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full">
                    <mat-label>{{"iswc" | transloco}} <form-field-tooltip tooltipTitleKey="iswc"
                        tooltipKey="track-iswc-tooltip"></form-field-tooltip></mat-label>
                    <input [formControlName]="'iswc'" autocomplete="off" matInput>
                </mat-form-field>
            </div>

            <!-- Preview -->
            <div class="flex flex-col md:flex-row md:space-x-6 space-y-6 md:space-y-0 pb-4">
                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full md:w-1/3">
                    <mat-label>Preview Start</mat-label>
                    <input [formControlName]="'previewStartString'" matInput>
                </mat-form-field>

                <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full md:w-1/3">
                    <mat-label>Preview Duration</mat-label>
                    <mat-select [formControlName]="'previewDuration'">
                        <mat-option [value]="10">0:10</mat-option>
                        <mat-option [value]="15">0:15</mat-option>
                        <mat-option [value]="20">0:20</mat-option>
                        <mat-option [value]="25">0:25</mat-option>
                        <mat-option [value]="30">0:30</mat-option>
                        <mat-option [value]="35">0:35</mat-option>
                        <mat-option [value]="40">0:40</mat-option>
                        <mat-option [value]="45">0:45</mat-option>
                        <mat-option [value]="50">0:50</mat-option>
                        <mat-option [value]="55">0:55</mat-option>
                        <mat-option [value]="60">0:60</mat-option>
                    </mat-select>
                </mat-form-field>

                <button (click)="playPreview()" [color]="'primary'" class="w-full md:w-1/3 self-end" mat-flat-button
                    type="button">
                    <mat-icon *ngIf="!audioPlayer || audioPlayer.paused" [svgIcon]="'heroicons_solid:play'"
                        class="icon-size-5 text-current mr-2"></mat-icon>
                    <mat-icon *ngIf="audioPlayer && !audioPlayer.paused" [svgIcon]="'heroicons_solid:stop'"
                        class="icon-size-5 text-current mr-2"></mat-icon>
                    {{audioPlayer && !audioPlayer.paused ? t('stop-playback-tooltip') : t('play-preview-button')}}
                </button>
            </div>
        </form>

        <div
            class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-white dark:bg-transparent text-on-primary border-t">
            <div class="flex justify-end w-full">
                <button [color]="'primary'" [disabled]="trackForm.pristine" class="px-8" form="track-form"
                    mat-flat-button type="submit">
                    {{t('save-button')}}
                </button>
            </div>
        </div>
    </div>
</ng-template>
